export const ADD_BULK_SELECT = "ADD_BULK_SELECT";
export const DELETE_BULK_SELECT = "DELETE_BULK_SELECT";
export const CLEAR_BULK_SELECT = "CLEAR_BULK_SELECT";
export const DELETE_MODAL_OPEN = "DELETE_MODAL_OPEN";
export const SET_BULK_SELECT = "SET_BULK_SELECT";